<template>
	<div>
		<div style="width: 100%;display: flex;">
			<div style="width: 50%;">
				<div style="width: 95%;" class="d-flex a-center">
					<div style="width: 90px;" class="acs">公司名称</div>
					<el-input v-model="form.name" placeholder="公司名称" size="mini"></el-input>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">税号</div>
					<el-input v-model="form.sh" placeholder="税号" size="mini"></el-input>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">开户银行</div>
					<el-input v-model="form.khyh" placeholder="开户银行" size="mini"></el-input>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">银行账号</div>
					<el-input v-model="form.yhzh" placeholder="银行账号" size="mini"></el-input>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">公司地址</div>
					<el-input v-model="form.gsdz" placeholder="公司地址" size="mini"></el-input>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">电话</div>
					<el-input v-model="form.dh" placeholder="电话" size="mini"></el-input>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">传真</div>
					<el-input v-model="form.cz" placeholder="传真" size="mini"></el-input>
				</div>
				
				
			</div>
			<div style="width: 50%;">
				<div style="width: 95%;" class="d-flex a-center">
					<div style="width: 90px;" class="acs">邮箱</div>
					<el-input v-model="form.email" placeholder="邮箱" size="mini"></el-input>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:90px;font-size: 14px;text-align: right;padding-right: 28px;">公司性质</div>
					<template>
						<el-radio v-model="radio" label="0">一般纳税人</el-radio>
						<el-radio v-model="radio" label="1">小规模纳税人</el-radio>
					</template>
				</div>
				<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
					<div style="width:90px;font-size: 14px;text-align: right;padding-right: 28px;">税率</div>
					<template>
						<el-radio v-model="radio1" label="0">13%</el-radio>
						<el-radio v-model="radio1" label="1">3%</el-radio>
					</template>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">货币</div>
					<el-input v-model="form.hb" placeholder="RMB" size="mini"></el-input>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">货币名称</div>
					<el-input v-model="form.hbmc" placeholder="人民币" size="mini"></el-input>
				</div>
				<div style="width: 95%;" class="d-flex a-center mt-4">
					<div style="width: 90px;" class="acs">货币小数</div>
					<el-input v-model="form.hbxs" placeholder="2" size="mini"></el-input>
				</div>
			</div>
		</div>
		<div style="width: 100%;display: flex; justify-content: center;">
			<el-button type="primary" @click="onSubmit" style="margin-top: 30px;">提交保存</el-button>
		</div>
	</div>
</template>

<script>
	import common from '@/common/mixins/common.js'; // 引入 全局共公样式
	export default {
		inject:['layout'],
		mixins:[common], // 引入mixins里的common.js
		data() {
			return {
				tableData: [],
				radio: '1',
				radio1: '0',
				createModel:false,				
				form:{},
			}
		},
		mounted() {
			this.getlist()
		},
		methods: {
			getlist(){
				this.axios.get('/admin/qiye',{ token: true })
					.then(res => {
						this.form = res.data.data
						this.radio = res.data.data.gsxz
						this.radio1 = res.data.data.sl
					})
					.catch(err => {
						this.hideLoading();
					});
			},
			onSubmit(){
				let e = {
					name:this.form.name,
					sh:this.form.sh,
					khyh:this.form.khyh,
					yhzh:this.form.yhzh,
					gsdz:this.form.gsdz,
					dh:this.form.dh,
					cz:this.form.cz,
					email:this.form.email,
					gsxz:this.radio,
					sl:this.radio1,
					hb:this.form.hb,
					hbmc:this.form.hbmc,
					hbxs:this.form.hbxs
				}
				this.axios.post('/admin/qiye/1', e, { token: true })
					.then(res => {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.getlist();
					})
			},
			
		},
	}
</script>

<style>
	.j-center{
		justify-content: center;
	}
	.a-center{
		align-items: center;
	}
	.j-j{
		flex-flow: column;
	}
	.acs{
		width:20%;font-size: 14px;text-align: right;padding-right: 10px;
	}
</style>
